module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_125-5ff30a1077a50fc26d9728d5d9d447dd.png";